import {ImagePlus} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const AddAPhotoIcon = createLucideIcon(ImagePlus, 'AddAPhotoIcon');
